import React from 'react';

export type NormalizedLinkContextType = {
  inEnterpriseContext: boolean;
};
export const NormalizedLinkContext = React.createContext<NormalizedLinkContextType>({
  inEnterpriseContext: false,
});
